export const LOADING_MODULE = "LOADING_MODULE";
export const GET_MODULE = "GET_MODULE";